export default {
  h1: {
    fontSize: 35,
    fontWeight: 500,
    letterSpacing: '-0.24px'
  },
  h2: {
    fontSize: 29,
    fontWeight: 500,
    letterSpacing: '-0.24px'
  },
  h3: {
    fontSize: 24,
    fontWeight: 500,
    letterSpacing: '-0.06px'
  },
  h4: {
    fontSize: 20,
    fontWeight: 500,
    letterSpacing: '-0.06px'
  },
  h5: {
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: '-0.05px'
  },
  h6: {
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: '-0.05px'
  },
  overline: {
    fontWeight: 500
  }
};
